import { render, staticRenderFns } from "./ContractHistorique.vue?vue&type=template&id=65f51335&"
import script from "./ContractHistorique.vue?vue&type=script&lang=js&"
export * from "./ContractHistorique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports